module.exports = __webpack_public_path__ + "static/media/paid-search-illustr-2.706255eb.png";